import { render } from "./ShipmentLineBoxesDetail.vue?vue&type=template&id=aa4ae232"
import script from "./ShipmentLineBoxesDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentLineBoxesDetail.vue?vue&type=script&lang=js"

import "./ShipmentLineBoxesDetail.vue?vue&type=style&index=0&id=aa4ae232&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__